import React from "react";
import ItemsSlider from "theme/components/organisms/ItemsSlider/ItemsSlider";
import { useSliderState } from "theme/components/organisms/Slider/Slider";
import ImageSkeleton from "theme/components/atoms/Image/ImageSkeleton";

const GalleryNavigationSkeleton = ({ numberOfVisibleThumbnails }) => {
  const sliderProps = useSliderState(numberOfVisibleThumbnails);
  return (
    <ItemsSlider
      sliderProps={sliderProps}
      itemsPerSlide={numberOfVisibleThumbnails}
      appearance="vertical"
    >
      {new Array(2).fill(null).map((_, index) => {
        return (
          <div key={`skeleton-${index}`}>
            <ImageSkeleton format="galleryPreview" appearance="full" />
          </div>
        );
      })}
    </ItemsSlider>
  );
};

export default GalleryNavigationSkeleton;
